export const checkIcon = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none">
  <path d="M20 6L9 17l-5-5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
</svg>`;
